import commons from './it/commons.json'
import attributes from './it/attributes.json'
import models from './it/models.json'
import account from './it/account.json'
import errors from './it/errors.json'
import cookie from './it/cookie.json'
import { it } from 'vuetify/locale'

//custom vuetify locales
it.fileUpload.title = "Trascina qui il file";
it.fileUpload.divider = "oppure";
it.fileUpload.browse = "Seleziona il file";

const lang = {
    $vuetify: it,
    commons: commons,
    attributes: attributes,
    models:models,
    account: account,
    errors: errors,
    cookie:cookie
}

export default lang